module.exports = __webpack_public_path__ + "images/category_lp/common/icon-step3@2x_8da25d75963773b96cec0c3d30a864f8.png";